import React from 'react';
import { Button, makeStyles } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  footer: {
    textAlign: 'right'
  },
  button: {
    marginLeft: theme.spacing(2)
  }
}));


/**
 * Submit Buttons.
 * @param {onSubmit, onCancel} props 
 */
function SubmitButtons(props) {
  const { onSubmit, onCancel } = props;
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <Button
        variant='outlined'
        color='secondary'
        className={classes.button}
        onClick={onCancel}
      >
        CANCEL
      </Button>
      <Button
        variant='outlined'
        color='primary'
        className={classes.button}
        onClick={onSubmit}
      >
        SAVE
      </Button>
    </div>
  );
}

export default SubmitButtons;
